module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_ack_r1.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_itr_r1.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_p01_r1.htm"
    }
  }, [_c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Part 1: Subjectivity, Knowledge, and Human Nature in Neo-Noir")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c01_r1.htm"
    }
  }, [_vm._v("Space, Time, and Subjectivity in Neo-Noir Cinema"), _c('br'), _c('em', [_vm._v("Jerold J. Abrams")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c02_r1.htm"
    }
  }, [_c('em', [_vm._v("Blade Runner")]), _vm._v(" and Sartre: The Boundaries of Humanity"), _c('br'), _c('em', [_vm._v("Judith Barad")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c03_r1.htm"
    }
  }, [_vm._v("John Locke, Personal Identity, and "), _c('em', [_vm._v("Memento"), _c('br'), _vm._v("Basil Smith")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c04_r1.htm"
    }
  }, [_vm._v("Problems of Memory and Identity in Neo-Noir’s Existentialist Antihero"), _c('br'), _c('em', [_vm._v("Andrew Spicer")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_p02_r1.htm"
    }
  }, [_c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Part 2: Justice, Guilt, and Redemption: Morality in Neo-Noir")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c05_r1.htm"
    }
  }, [_vm._v("The Murder of Moral Idealism: Kant and the Death of Ian Campbell in "), _c('em', [_vm._v("The Onion Field")]), _c('br'), _c('em', [_vm._v("Douglas L. Berger")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c06_r1.htm"
    }
  }, [_vm._v("Justice and Moral Corruption in A Simple Plan"), _c('br'), _c('em', [_vm._v("Aeon J. Skoble")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c07_r1.htm"
    }
  }, [_vm._v("“Saint” Sydney: Atonement and Moral Inversion in "), _c('em', [_vm._v("Hard Eight")]), _c('br'), _c('em', [_vm._v("Donald R. D’Aries and Foster Hirsch")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c08_r1.htm"
    }
  }, [_c('em', [_vm._v("Reservoir Dogs:")]), _vm._v(" Redemption in a Postmodern World"), _c('br'), _c('em', [_vm._v("Mark T. Conard")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_p01_r1.htm"
    }
  }, [_c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Part 3: Elements of Neo-Noir")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c09_r1.htm"
    }
  }, [_vm._v("The Dark Sublimity of "), _c('em', [_vm._v("Chinatown")]), _c('br'), _c('em', [_vm._v("Richard Gilmore")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c10_r1.htm"
    }
  }, [_vm._v("The Human Comedy Perpetuates Itself: Nihilism and Comedy in Coen Neo-Noir"), _c('br'), _c('em', [_vm._v("Thomas S. Hibbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c11_r1.htm"
    }
  }, [_vm._v("The New Sincerity of Neo-Noir: The Example of "), _c('em', [_vm._v("The Man Who Wasn’t There")]), _c('br'), _c('em', [_vm._v("R. Barton Palmer")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c12_r1.htm"
    }
  }, [_vm._v("“Anything Is Possible Here”: Capitalism, Neo-Noir, and "), _c('em', [_vm._v("Chinatown")]), _c('br'), _c('em', [_vm._v("Jeanne Schuler and Patrick Murray")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_c13_r1.htm"
    }
  }, [_vm._v("Sunshine Noir: Postmodernism and "), _c('em', [_vm._v("Miami Vice")]), _c('br'), _c('em', [_vm._v("Steven M. Sanders")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_app_r1.htm"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780813172309_epub_ind_r1.htm"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a2a4cea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780813172309_epub_toc_r1.vue
// module id = 69
// module chunks = 0